// src/layouts/Pages/PageHeader/CardHeaderColumn/items/paymentMethod.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { CreditCardOutlined } from '@ant-design/icons';
import translateX from 'utils/translateX';

// *******************************************************************************
// ITEM FUNCTION
// *******************************************************************************
// Payment method labels by contract key
const PAYMENT_METHODS = {
  BANK_SLIP: 'bank_slip',
  CREDIT_CARD: 'credit_card',
  PIX: 'pix',
  DEBIT: 'debit',
};

export const paymentMethodItem = (record, contract) => {
  if (!record?._id) return;

  const label = contract?.PAYMENT_METHOD
    ? translateX(PAYMENT_METHODS[contract.PAYMENT_METHOD] || contract.PAYMENT_METHOD)
    : record?.paymentMethod || null;

  if (!label) return;

  return {
    key: 'paymentMethod',
    icon: <CreditCardOutlined />,
    label,
    tooltipText: translateX('payment_method'),
    tooltipPlacement: 'right',
    onClick: null,
  };
};

export default paymentMethodItem;
